import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';

function TrialPage() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    level: 'beginner'
  });

  const handleInputChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    
    const GOOGLE_SCRIPT_URL = 'https://script.google.com/macros/s/AKfycbwqahxqztwE0vWHp_9ps2hpW8-lyB_jitEeVV7f2ZfxxGT--T_Ec6d4lynRCLRKDaMm/exec';
    
    try {
      await fetch(GOOGLE_SCRIPT_URL, {
        method: 'POST',
        mode: 'no-cors',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          ...formData,
          source: 'Free Ebook',
          timestamp: new Date().toISOString()
        })
      });
      
      alert('¡Perfecto! Te hemos enviado tu Ebook gratuito por email. ¡Revisa tu bandeja de entrada!');
      setFormData({ name: '', email: '', level: 'beginner' });
    } catch (error) {
      console.error('Error:', error);
      alert('Hubo un error. Por favor intenta de nuevo.');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen bg-white">
      {/* Navigation Header */}
      <nav className="bg-white shadow-lg sticky top-0 z-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-20">
            <div className="flex items-center">
              <Link to="/" className="flex items-center">
                <img src="/logo.webp" alt="Vencejo Academy Logo" className="h-12 w-auto mr-3" />
                <span className="text-3xl font-display font-bold text-primary-600">Vencejo Academy</span>
              </Link>
            </div>
            <div className="hidden md:flex space-x-8 items-center">
              <Link to="/store" className="text-gray-700 hover:text-primary-600 transition font-medium">STORE</Link>
              <Link to="/blog" className="text-gray-700 hover:text-primary-600 transition font-medium">BLOG</Link>
              <Link to="/contact" className="text-gray-700 hover:text-primary-600 transition font-medium">CONTACT</Link>
              <Link to="/tutoring-hub" className="text-gray-700 hover:text-primary-600 transition font-medium">TUTORING HUB</Link>
              <Link to="/free-ebook" className="font-medium text-red-600 hover:text-red-700 transition">FREE EBOOK</Link>
            </div>
            <div className="md:hidden">
              <button 
                onClick={() => setIsMenuOpen(!isMenuOpen)}
                className="text-gray-700 focus:outline-none"
              >
                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  {isMenuOpen ? (
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                  ) : (
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
                  )}
                </svg>
              </button>
            </div>
          </div>
          {isMenuOpen && (
            <div className="md:hidden py-4 space-y-4">
              <Link to="/store" className="block text-gray-700 hover:text-primary-600 transition">STORE</Link>
              <Link to="/blog" className="block text-gray-700 hover:text-primary-600 transition">BLOG</Link>
              <Link to="/contact" className="block text-gray-700 hover:text-primary-600 transition">CONTACT</Link>
              <Link to="/tutoring-hub" className="block text-gray-700 hover:text-primary-600 transition">TUTORING HUB</Link>
              <Link to="/free-ebook" className="block font-medium text-red-600 hover:text-red-700 transition text-center">FREE EBOOK</Link>
            </div>
          )}
        </div>
      </nav>

      {/* Hero Section */}
      <section 
        className="relative py-24 lg:py-32 overflow-hidden bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: 'url(/images/spanish.learn.webp)',
          backgroundColor: '#FEF9C3'
        }}
      >
        {/* Background Overlay */}
        <div className="absolute inset-0 bg-gradient-to-br from-secondary-100/95 via-secondary-50/92 to-primary-50/95"></div>
        
        {/* Gradient Overlay */}
        <div className="absolute inset-0 opacity-5">
          <div className="absolute top-0 left-0 w-96 h-96 bg-primary-300 rounded-full blur-3xl"></div>
          <div className="absolute bottom-0 right-0 w-96 h-96 bg-secondary-300 rounded-full blur-3xl"></div>
        </div>
        
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center z-10">
          <h1 className="text-5xl md:text-7xl font-display font-bold text-gray-900 mb-6 leading-tight">
            Get Your
            <br />
            <span className="text-red-600">Free Spanish Ebook</span>
          </h1>
          <h2 className="text-2xl md:text-4xl font-display font-semibold text-gray-700 mb-8">
            Complete your details and receive your free ebook!
          </h2>
          <p className="text-xl text-gray-600 mb-10 max-w-3xl mx-auto">
            Experience our unique Spanish learning system through our exclusive introductory ebook. 
            No credit card required - download yours today!
          </p>
        </div>
      </section>

      {/* Trial Form Section */}
      <section className="py-20 bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="bg-gradient-to-br from-red-50 to-orange-50 rounded-3xl p-8 md:p-12 shadow-2xl border border-red-100">
            <div className="text-center mb-8">
              <h2 className="text-3xl md:text-4xl font-display font-bold text-gray-900 mb-4">
                Receive Your Free Ebook
              </h2>
              <p className="text-lg text-gray-700">
                Includes essential Spanish phrases, cultural secrets, and learning strategies
              </p>
            </div>

            <form onSubmit={handleSubmit} className="max-w-md mx-auto space-y-6">
              <div>
                <label htmlFor="name" className="block text-sm font-medium text-gray-700 mb-2">
                  Your Name
                </label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  required
                  value={formData.name}
                  onChange={handleInputChange}
                  disabled={isSubmitting}
                  className="w-full px-4 py-3 border-2 border-gray-300 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-transparent text-lg"
                  placeholder="Enter your full name"
                />
              </div>

              <div>
                <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-2">
                  Email Address
                </label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  required
                  value={formData.email}
                  onChange={handleInputChange}
                  disabled={isSubmitting}
                  className="w-full px-4 py-3 border-2 border-gray-300 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-transparent text-lg"
                  placeholder="your.email@example.com"
                />
              </div>

              <div>
                <label htmlFor="level" className="block text-sm font-medium text-gray-700 mb-2">
                  Your Spanish Level
                </label>
                <select
                  id="level"
                  name="level"
                  value={formData.level}
                  onChange={handleInputChange}
                  disabled={isSubmitting}
                  className="w-full px-4 py-3 border-2 border-gray-300 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-transparent text-lg"
                >
                  <option value="beginner">Beginner (A1-A2)</option>
                  <option value="intermediate">Intermediate (B1-B2)</option>
                  <option value="advanced">Advanced (C1-C2)</option>
                </select>
              </div>

              <button
                type="submit"
                disabled={isSubmitting}
                className="w-full bg-gradient-to-r from-primary-600 to-secondary-500 text-white px-8 py-4 rounded-lg text-lg font-bold hover:from-primary-700 hover:to-secondary-600 transition-all shadow-xl transform hover:scale-105 disabled:opacity-50 disabled:transform-none"
              >
                {isSubmitting ? 'Sending...' : 'Get My Free Ebook'}
              </button>
            </form>

            <div className="mt-8 text-center">
              <p className="text-sm text-gray-600">
                ✓ No credit card required  ✓ Instant access  ✓ Cancel anytime
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* What You'll Get Section */}
      <section className="py-20" style={{ backgroundColor: '#FF6B6B' }}>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-display font-bold text-white mb-4">
              What's Inside Your Free Ebook
            </h2>
            <p className="text-xl text-white/90">
              Everything you need to jumpstart your Spanish journey
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            <div className="bg-white p-8 rounded-2xl shadow-xl hover:shadow-2xl transition-shadow">
              <h3 className="text-xl font-bold text-gray-900 mb-3">5 Song Translations</h3>
              <p className="text-gray-700">
                Complete lyrics with English translations and grammar explanations for popular Spanish songs
              </p>
            </div>

            <div className="bg-white p-8 rounded-2xl shadow-xl hover:shadow-2xl transition-shadow">
              <h3 className="text-xl font-bold text-gray-900 mb-3">Interactive Game</h3>
              <p className="text-gray-700">
                Try our vocabulary game with 50+ words and phrases. Works on mobile and desktop
              </p>
            </div>

            <div className="bg-white p-8 rounded-2xl shadow-xl hover:shadow-2xl transition-shadow">
              <h3 className="text-xl font-bold text-gray-900 mb-3">Sample Ebook</h3>
              <p className="text-gray-700">
                Short story with audio narration, perfect for your level with vocabulary lists
              </p>
            </div>

            <div className="bg-white p-8 rounded-2xl shadow-xl hover:shadow-2xl transition-shadow">
              <h3 className="text-xl font-bold text-gray-900 mb-3">Film Recommendations</h3>
              <p className="text-gray-700">
                3 curated Spanish movies with study guides and cultural context
              </p>
            </div>

            <div className="bg-white p-8 rounded-2xl shadow-xl hover:shadow-2xl transition-shadow">
              <h3 className="text-xl font-bold text-gray-900 mb-3">Quiz & Exercises</h3>
              <p className="text-gray-700">
                Interactive quizzes to test your knowledge with instant feedback
              </p>
            </div>

            <div className="bg-white p-8 rounded-2xl shadow-xl hover:shadow-2xl transition-shadow">
              <h3 className="text-xl font-bold text-gray-900 mb-3">Recipe Sample</h3>
              <p className="text-gray-700">
                Authentic Spanish recipe with cooking vocabulary and cultural insights
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Success Stories */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-display font-bold text-gray-900 mb-4">
              Join 150,000+ Happy Learners
            </h2>
            <div className="w-24 h-1 bg-gradient-to-r from-primary-600 to-secondary-500 mx-auto rounded-full"></div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="bg-gradient-to-br from-primary-50 to-secondary-50 p-8 rounded-2xl">
              <div className="flex items-center mb-4">
                <div className="flex text-yellow-400">
                  ⭐⭐⭐⭐⭐
                </div>
              </div>
              <p className="text-gray-700 mb-4 italic">
                "The music approach is genius! I learned more Spanish in 2 weeks than in 6 months of traditional classes."
              </p>
              <div className="font-semibold text-gray-900">- Sarah M., USA</div>
            </div>

            <div className="bg-gradient-to-br from-secondary-50 to-primary-50 p-8 rounded-2xl">
              <div className="flex items-center mb-4">
                <div className="flex text-yellow-400">
                  ⭐⭐⭐⭐⭐
                </div>
              </div>
              <p className="text-gray-700 mb-4 italic">
                "Perfect for my trip to Spain! The cultural insights and travel phrases were incredibly helpful."
              </p>
              <div className="font-semibold text-gray-900">- James L., UK</div>
            </div>

            <div className="bg-gradient-to-br from-primary-50 to-secondary-50 p-8 rounded-2xl">
              <div className="flex items-center mb-4">
                <div className="flex text-yellow-400">
                  *****
                </div>
              </div>
              <p className="text-gray-700 mb-4 italic">
                "The interactive games make learning fun! My kids love them too. Great family learning experience."
              </p>
              <div className="font-semibold text-gray-900">- Maria C., Canada</div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20" style={{ backgroundColor: '#1a1a1a' }}>
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-4xl md:text-5xl font-display font-bold text-white mb-6">
            Ready to start learning Spanish?
          </h2>
          <p className="text-xl text-white/80 mb-8">
            Get your free ebook now and discover why thousands choose our method
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a 
              href="#trial-form" 
              onClick={(e) => {
                e.preventDefault();
                document.querySelector('form').scrollIntoView({ behavior: 'smooth' });
              }}
              className="bg-primary-600 text-white px-10 py-4 rounded-lg text-lg font-semibold hover:bg-primary-700 transition transform hover:scale-105 shadow-lg"
            >
              Get Free Ebook
            </a>
            <Link 
              to="/store" 
              className="bg-white text-gray-900 px-10 py-4 rounded-lg text-lg font-semibold hover:bg-gray-100 transition transform hover:scale-105"
            >
              View All Products
            </Link>
          </div>
        </div>
      </section>

      {/* Shared Footer */}
      <Footer />
    </div>
  );
}

export default TrialPage;